var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('glp-steps',{attrs:{"active":_vm.active,"process":""}},_vm._l((_vm.options),function(row){return _c('glp-step',{key:row.key,attrs:{"title":row.title}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }